import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { LockKey } from "@phosphor-icons/react";
import {
  AccessControlItem,
  AccessType,
  ACCESS_TYPE_LABELS,
  ACCESS_TYPE_COLORS,
} from "../types/accessControl";

interface AccessControlDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: AccessControlItem;
}

const AccessControlDetailModal: React.FC<AccessControlDetailModalProps> = ({
  isOpen,
  onClose,
  item,
}) => {
  const typeBadge = item.accessType ? (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${ACCESS_TYPE_COLORS[item.accessType as AccessType]}`}
    >
      {ACCESS_TYPE_LABELS[item.accessType as AccessType]}
    </span>
  ) : (
    <span className="text-neutral-secondary-mid text-sm">-</span>
  );

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <LockKey className="h-5 w-5 text-moss-primary" weight="duotone" />
            Toegangscontrole details
          </DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-4 pt-2">
          <div className="space-y-1">
            <Label className="text-neutral-secondary-mid text-xs">Gebouw</Label>
            <p className="text-sm font-medium text-neutral-primary">
              {item.building?.id || item.buildingId || "-"}
            </p>
          </div>

          <div className="space-y-1">
            <Label className="text-neutral-secondary-mid text-xs">Unit</Label>
            <p className="text-sm font-medium text-neutral-primary">
              {item.unit?.id || item.unitId || "-"}
            </p>
          </div>

          <div className="space-y-1">
            <Label className="text-neutral-secondary-mid text-xs">Type Toegang</Label>
            <div>{typeBadge}</div>
          </div>

          <div className="space-y-1">
            <Label className="text-neutral-secondary-mid text-xs">Locatie Sleutel</Label>
            <p className="text-sm font-medium text-neutral-primary">
              {item.keyLocation || "-"}
            </p>
          </div>

          <div className="col-span-2 space-y-1">
            <Label className="text-neutral-secondary-mid text-xs">Additionele informatie</Label>
            <p className="text-sm font-medium text-neutral-primary">
              {item.additionalInfo || "-"}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AccessControlDetailModal;
